const svgSources = {
  thenounproject: {
    href: 'https://thenounproject.com/',
    text: 'thenounproject',
  },
  svgrepo: {
    href: 'https://www.svgrepo.com/',
    text: 'svgrepo',
  },
  svgsilh: {
    href: 'https://svgsilh.com/',
    text: 'svgsilh',
  },
  vectorhq: {
    href: 'https://www.vectorhq.com/',
    text: 'vectorhq',
  },
};

export default svgSources;
